import type { AgentToolRegistry } from '../../../../core/ai/agent/AgentToolRegistry';
import { queryTool } from './queryTool';
import { highlightPathTool } from './highlightPathTool';
import { layoutTool } from './layoutTool';

export const registerFlowchartAgentTools = (registry: AgentToolRegistry): void => {
  registry.register(queryTool);
  registry.register(highlightPathTool);
  registry.register(layoutTool);
};
